<script lang="ts" setup>
import { computed } from 'vue'
import { $date } from '@/plugins'
import { PILL_STATUS_TYPES } from '@/components/micro/Pills/BasePill/base-pill.types'
import type { Kit } from '@/components/drawers/MemberDrawer/types/member-drawer.types'

const props = defineProps<{
  items: Kit[]
}>()

const itemsParsed = computed(() => props.items?.map((item) => ({
  ...item,
  updated_at: item.updated_at ? $date(item.updated_at).format('MMM D, YYYY, HH:mm') : '-',
})) || [])
</script>

<template>
  <sword-popover-wuk class="all-kits" :distance="10" placement="bottom-end">
    <sword-button-wuk
      v-if="items.length"
      theme="secondary"
      icon="box"
      size="small"
      side="left"
      text="button.all_kits"
      class="-mx_0"
    />
    <template #content>
      <div class="all-kits-popover">
        <header>
          <span>{{ $t('SIDEBAR.KIT') }}</span>
          <span>{{ $t('PATIENTS.STATUS') }}</span>
          <span>{{ $t('COMMON.LAST_UPDATE') }}</span>
        </header>
        <div v-for="(item, itemIndex) of itemsParsed" :key="itemIndex" class="kit-item">
          <span class="t2 -t_medium">{{ $t(item.product_type) }}</span>
          <div class="flex">
            <base-pill :type="PILL_STATUS_TYPES.KIT" :status="item.status" />
          </div>
          <span class="t2 -t_medium">{{ item.updated_at }}</span>
        </div>
      </div>
    </template>
  </sword-popover-wuk>
</template>

<style lang="scss" scoped>
.all-kits {
  position: relative;
  display: inline-block;
  margin-left: auto;

  &-popover {
    padding: 1rem;
    width: 30rem;

    .kit-item, header {
      display: grid;
      grid-template-columns: 1fr 1fr 11rem;
      grid-gap: 1rem;
    }

    header {
      margin-bottom: $space-sm;
      color: $color-grey-600;
    }

    .kit-item {
      margin-bottom: $space-xs;
    }
  }
}
</style>
